/**
 * El borrador de una recomendación, en `localStorage`.
 *
 * docs/03 §4.3 lo promete en los estados 1 y 4 —"tu borrador está a salvo"— y
 * esa promesa es lo que hace tolerable la ventana de 72 h: que expire el
 * token no expira el trabajo de la persona.
 *
 * ADR-016 §7: esto NO es una capacidad offline y no reabre ADR-006. Es texto
 * de una persona en su propio navegador. No hay cola de sync, ni IndexedDB,
 * ni reintentos, ni lectura degradada.
 */

const PREFIJO = 'gu.draft.';

/**
 * Lee sin lanzar nunca.
 *
 * Safari en modo privado puede lanzar también al LEER, y un throw aquí rompe
 * la pantalla al entrar: ni siquiera se llegaría a ver el lugar.
 */
export function readDraft(placeId: string): string {
  try {
    return localStorage.getItem(PREFIJO + placeId) ?? '';
  } catch {
    return '';
  }
}

/**
 * Guarda sin lanzar nunca.
 *
 * Safari en privado lanza `QuotaExceededError` al escribir. Perder el
 * borrador es malo; que la pantalla entera se rompa mientras alguien escribe
 * es peor.
 */
export function saveDraft(placeId: string, texto: string): void {
  try {
    localStorage.setItem(PREFIJO + placeId, texto);
  } catch {
    // Sin borrador, pero con pantalla.
  }
}

export function clearDraft(placeId: string): void {
  try {
    localStorage.removeItem(PREFIJO + placeId);
  } catch {
    // Nada que hacer.
  }
}
